// Client layer (TS-2.5.03) - presentational. Renders an ImportResult's written-row counts
// (D-197's committed counts) and any leftover issues, and offers a way back to a clean upload step.
import type { ImportResult } from "../../api/generated/contracts";
import { strings } from "../../strings";

export interface ImportResultSummaryProps {
  readonly result: ImportResult;
  readonly onStartAnother: () => void;
}

const S = strings.import.result;

export function ImportResultSummary({ result, onStartAnother }: ImportResultSummaryProps) {
  return (
    <section className="eg-import-result" aria-labelledby="eg-import-result-heading">
      <h2 id="eg-import-result-heading">{S.heading}</h2>
      <dl>
        <dt>{S.projectsWritten}</dt>
        <dd>{result.projectsWritten}</dd>
        <dt>{S.milestonesWritten}</dt>
        <dd>{result.milestonesWritten}</dd>
        <dt>{S.notesWritten}</dt>
        <dd>{result.notesWritten}</dd>
        <dt>{S.requestsWritten}</dt>
        <dd>{result.requestsWritten}</dd>
      </dl>

      {result.issues.length > 0 && (
        <>
          <h3>{S.issues}</h3>
          <ul>
            {result.issues.map((issue, index) => (
              <li key={index}>{issue}</li>
            ))}
          </ul>
        </>
      )}

      <button type="button" onClick={onStartAnother}>
        {S.startAnother}
      </button>
    </section>
  );
}
